<template>
  <tr
    class="hover:ps-bg-gray-50 cursor-pointer"
    @click.stop="$emit('click', dot.id)"
  >
    <td
      class="px-6 py-3 max-w-0 w-full whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
    >
      <div class="flex items-center space-x-3 lg:pl-2">
        <span
          :class="{ 'bg-blue-100': isAssignedToCurrentUser }"
          class="flex-shrink-0 h-4 w-4 rounded-full flex items-center justify-center"
        >
          <span
            :class="[dotBgColor, dotOpacity]"
            class="h-2 w-2 rounded-full"
          ></span>
        </span>

        <a href.prevent="#" class="truncate hover:text-gray-600">
          <span
            >{{ card.name }}

            <span v-if="card.list" class="text-gray-500 font-normal"
              >in {{ card.list.name }}</span
            >
            <span v-if="card.priority" class="ps-px-3 ps-text-xxs">
              <span
                :class="[generateColors(card.priority.icon_color)]"
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4"
                >{{ card.priority.name }}</span
              >
            </span>
          </span>
        </a>
      </div>
    </td>
    <td class="px-6 py-3 text-sm leading-5 text-gray-500 font-medium">
      <div class="flex items-center space-x-2">
        <div class="flex flex-shrink-0 -space-x-1">
          <user-avatar
            class="max-w-none h-6 w-6 rounded-full text-white shadow-solid"
            :user="card.created_by_user"
          />
          <user-avatar
            v-if="card.assigned_to_user"
            class="max-w-none h-6 w-6 rounded-full text-white shadow-solid"
            :user="card.assigned_to_user"
          />
        </div>
      </div>
    </td>
    <td
      class="hidden md:table-cell px-6 py-3 whitespace-no-wrap text-sm leading-5 text-gray-500 text-right"
    >
      {{ card.created_at.month_short }}
    </td>
    <td class="pr-6">
      <div class="relative flex justify-end items-center">
        <button
          id="project-options-menu-0"
          aria-has-popup="true"
          type="button"
          @click.stop="isMenuOpen = !isMenuOpen"
          class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100 transition ease-in-out duration-150"
        >
          <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
            />
          </svg>
        </button>
        <!--
                      Dropdown panel, show/hide based on dropdown state.

                      Entering: "transition ease-out duration-100"
                        From: "transform opacity-0 scale-95"
                        To: "transform opacity-100 scale-100"
                      Leaving: "transition ease-in duration-75"
                        From: "transform opacity-100 scale-100"
                        To: "transform opacity-0 scale-95"
                    -->
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <div
            v-if="isMenuOpen"
            class="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg"
          >
            <div
              class="z-10 rounded-md bg-white shadow-xs"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="project-options-menu-0"
              @click.stop="isMenuOpen = false"
            >
              <div class="py-1">
                <a
                  href="#"
                  @click="copyLink"
                  class="group flex items-center px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                  role="menuitem"
                >
                  <svg
                    class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  Copy Link
                </a>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </td>
  </tr>
</template>

<script>
import ItemCardMixin from '@/mixins/item-card'

export default {
  name: 'ItemCardTable',
  mixins: [ItemCardMixin],
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    copyLink() {}
  }
}
</script>
